import DraggableStepCard from '../../DraggableStepCard';

export const content = ({ step }) => step.description;

export const getDescription = ({ step: { details }, t }) => {
  return t('Extract Content from ‘{{fieldName}}’ field', {
    fieldName: details?.sourceField?.label || t('File'),
  });
};

export default function FileExtractionCard({ step, ...others }) {
  return <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>;
}
